import { FileUploadDoiInventoryPolicy } from 'components/file-upload/file-upload-doi-inventory-policy';
import { LabelButton } from 'components/label-button';
import intl from "react-intl-universal";
import type { Step2DoiInventoryPolicyProps } from "../doi-inventory-policy-types";

const Step2DoiInventoryPolicy: React.FC<Step2DoiInventoryPolicyProps> = ({ errors, contextModal, noMessageExample, downloadModelFile, startFetching, stopFetching, handleReadFile, setCsv, setErrors, setFileName }) => {
  const handleDownloadModelFile = async () => {
    try {
      startFetching();
      await downloadModelFile();
    } catch (e) {
      console.error('Error occurred while downloading the model file:', e);
    } finally {
      stopFetching();
    }
  };

  return (
    <div className={`content ${errors ? "error-state" : ""}`}>
      <span className="title">
        {intl.get(`exportImportModal.${contextModal}.messageStep2`)}
      </span>
      <LabelButton
        className="title link"
        data-testid="download-model-import"
        onClick={handleDownloadModelFile}
      >
        {!noMessageExample &&
          intl.get(`exportImportModal.${contextModal}.downloadModelMessage`)}
      </LabelButton>
      <FileUploadDoiInventoryPolicy
        handleReadFile={handleReadFile}
        setCsv={setCsv}
        setErrors={setErrors}
        setFileName={setFileName}
      />
      {!!errors.length && (
        <div className="errors-content">
          <p>{intl.get("master-data.general-configuration.uploadErrors")}</p>
          <ul>
            {errors.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Step2DoiInventoryPolicy;
